import { TABLA_DETALLE_POR_CONDICION_LINEA_4 } from '../../../../../config/tables'
import { TablaDetallePorCondicionLinea4Service } from '../../../../../models/movimiento/distribucionDetallePorCondicion/Tabla_detalle_por_condicion_linea_4'
import { COLUMNS_DETALLE_POR_CONDICION_LINEA_4, COLUMNS_DETALLE_POR_CONDICION_LINEA_4_TO_PRINT } from './constantesDetallePorCondicionLinea4'
import { pdfCustomToolbarGenerator } from '../../../../../models/tools/generarPdf'

export function actualizarDatosParaMuiTable () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_DETALLE_POR_CONDICION_LINEA_4
    })
    const promiseTablaDetallePorCondicionLinea4 = TablaDetallePorCondicionLinea4Service.getDataTablaDetallePorCondicionLinea4()
    const promiseTablaDetallePorCondicionLinea4Total = TablaDetallePorCondicionLinea4Service.getDataTablaDetallePorCondicionLinea4Total()
    Promise.all([promiseTablaDetallePorCondicionLinea4, promiseTablaDetallePorCondicionLinea4Total]).then(callback)
    function callback (dataArray) {
      const dataCombinada = dataArray[0].filas || []
      const filaTotalArreglada = dataArray[1].filas[0]
      filaTotalArreglada['cereal'] = 'Total'
      dataCombinada.push(filaTotalArreglada)
      const customToolbar = pdfCustomToolbarGenerator(
        'Distribución Por Condición Sector 4',
        dataCombinada,
        COLUMNS_DETALLE_POR_CONDICION_LINEA_4_TO_PRINT,
        'portrait')
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_DETALLE_POR_CONDICION_LINEA_4,
          data: dataCombinada,
          title: `Distribución Por Condición Sector 4`,
          isLoading: false,
          fixed2Decimales: true,
          extraOptions: { customToolbar, pagination: false }
        },
        id: TABLA_DETALLE_POR_CONDICION_LINEA_4
      })
    }
  }
}
